/* global slater */

import radio from '@/lib/radio.js';
import getProductJson from '@/lib/getProductJson.js';
import Swiper from 'swiper';

export default function productSelection(node, opts) {
  opts = Object.assign({
    radio: '[data-option-radio]',
    main: '[data-option-main]',
  }, opts);

  const listeners = [];

  const state = {
    product: null,
    id: null,
    options: {}
  };

  getProductJson().then(json => {
    state.product = json;
  });

  const radios = slater.qsa(opts.radio);
  const main = slater.qs(opts.main);

  if (!main || !main.length) throw 'data-option-main is missing';
  if (radios.length > 3) throw 'you have more than three radio groups';

  radios.forEach(r => {
    if (r.nodeName === 'INPUT') throw 'data-option-radio should be defined on a parent of the radio group, not the inputs themselves';

    const position = parseInt(r.getAttribute('data-position'));
    const inputs = [].slice.call(r.getElementsByTagName('input'));

    radio(inputs, value => {
      state.options[`option${position}`] = value;
      updateSelection();
      updateSubsequentOptions(position, value);
    });
  });

  updateSelection();

  function updateSelection() {
    if (!state.product) return;
    const options = Object.keys(state.options).map((key) => {
      if (key.includes('option')) return state.options[key];
    });
    const productTitle = options.join(' / ');

    state.id = state.product.variants.find((variant) => {
      return variant.title === productTitle;
    })?.id || '';

    if (state.id) {
      updateVariantImage(state.id)
    }

    let params = new URLSearchParams(document.location.search);
    main.value = state.id || params.get('variant') || null;
    refreshButtonState();
    for (let fn of listeners) fn(state);
  }

  function updateVariantImage(id) {
    let slide = document.querySelector(`[data-variant-image='${id}']`);

    const slides = document.querySelectorAll('.swiper-gallery .swiper-slide');
    slides.forEach(function (slide, index) {
      console.log(id)
      if (slide.getAttribute('data-variant-image') == id) {
        var swiperElement = document.querySelector('.swiper-gallery').swiper
        swiperElement.slideTo(index);
        console.log('here')
      }
    });

    // // Hide all images
    // let allImages = document.querySelectorAll(`.c-product__media img`);
    // for (let i = 0; i < allImages.length; i++) {
    //   allImages[i].classList.add('hidden');
    // }

    // // Show selected variant
    // image.classList.remove('hidden')

  }

  function refreshButtonState() {
    fetch(`${window.location.pathname}?variant=${state.id || ''}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = node.querySelector('[data-live-add-to-cart]');
        const source = html.querySelector('[data-live-add-to-cart]');
        if (source && destination) destination.innerHTML = source.innerHTML;
      }).catch(e => {
        console.error(e);
      });
  }

  function getAvailableCombinations() {
    const product = JSON.parse(node.querySelector('.js-product-json').innerHTML);
    return product.variants.filter((variant) => {
      return Object.keys(state.options).every((key) => {
        return variant[key] === state.options[key];
      });
    });
  }


  function resetVariant(radio) {
    delete state.options[`option${radio.dataset.position}`];
    const radioLabel = radio.querySelector('.js-dropdown-selected');
    radioLabel.textContent = radioLabel.dataset.defaultLabel;
  }

  function updateSubsequentOptions(position) {
    radios.forEach((radio) => {
      // Ignore current and previous options
      if (radio.dataset.position <= position) return;
      // Reset subsequent options to unselected state
      resetVariant(radio);
    });

    const availableCombinations = getAvailableCombinations();

    radios.forEach((radio) => {
      // Items = dropdown list items
      const items = [...radio.querySelectorAll('label')];

      items.forEach((item) => {
        if (state.options[`option${radio.dataset.position}`]) return;

        const isAvailable = availableCombinations.some((variant) => {
          return variant[`option${radio.dataset.position}`] === item.getAttribute('for');
        });

        const input = item.querySelector('input');
        input.checked = false;
        input.toggleAttribute('disabled', !isAvailable);
        item.classList.toggle('is-disabled', !isAvailable);
      });
    });
  }

  return {
    get state() {
      return state;
    },
    onUpdate(fn) {
      listeners.indexOf(fn) < 0 && listeners.push(fn);
      return () => listeners.splice(listeners.indexOf(fn), 1);
    }
  };
}
